<template>
  <div class="dialogCreateFile">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="状态" prop="region">
        <el-select v-model="ruleForm.region" placeholder="请选择申请区域">
          <el-option
            v-for="(item, index) in regionList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册账号">
        <el-input
          v-model="ruleForm.name"
          placeholder="请输入注册账号"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="demantFromFooter">
      <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
    </div>
  </div>
</template>

<script>
import { acceptIcpPartnerNotification } from '@/api/alicp.js';
export default {
  props: ['BizId'],
  data() {
    return {
      ruleForm: {
        name: '',
        region: '',
      },
      rules: {
        name: [{ required: true, message: '请输入注册账号', trigger: 'blur' }],
        region: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      regionList: [
        // {
        //   value: 4,
        //   label: '工信部受理中-已注册',
        // },
        // {
        //   value: 5,
        //   label: '工信部受理中-已提交',
        // },
        {
          value: 509,
          label: '工信部受理中-已受理',
        },
        {
          value: 510,
          label: '工信部受理中-不予受理',
        },
        {
          value: 511,
          label: '工信部受理中-通过',
        },
        {
          value: 512,
          label: '工信部受理中-未通过',
        },
        {
          value: 508,
          label: '服务商完成提交资料到⼯信部',
        },
        {
          value: 507,
          label: '完成账户注册',
        },
      ],
    };
  },
  methods: {
    submitForm(formName) {
      let obj = {
        ApplicationStatus: this.ruleForm.region,
        BizId: this.BizId,
        OfficialFileUrl: '',
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('tolkParent', { loading: true, dialog: true });
          acceptIcpPartnerNotification(obj).then((res) => {
            if (res.status == 0) {
              this.$message({
                message: '修改状态成功！',
                type: 'success',
              });
              this.$emit('tolkParent', { loading: false, dialog: false });
            } else {
              this.$message({
                message: '修改状态失败！',
                type: 'success',
              });
              this.$emit('tolkParent', { loading: false, dialog: true });
            }
          });
        } else {
          this.$message({
            message: '请完善信息',
            type: 'warning',
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.dialogCreateFile {
  width: 100%;
  .el-form {
    width: 100%;
    .el-form-item {
      .el-form-item__content {
        .el-input {
          width: 400px;
          margin-right: 10px;
        }
        .el-input__inner:focus {
          border-color: #ff8a01;
        }
      }
    }
  }
  .distpicker-address-wrapper select {
    width: 190px;
  }
  .distpicker-address-wrapper select:nth-child(3) {
    display: none;
  }
  .demantFromFooter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      background: #ff8a01;
      border: none;
    }
  }
}
</style>
